import React from "react";
import { ImageOff, Library, Camera, X } from "lucide-react";
import { AuthImage } from "./AuthImage";
import { FilePickButton } from "./FilePickButton";
import { swatchImageUrl, attachmentImageUrl } from "./useFabricLibrary";

export function FabricThumb({ orderId, fabric, className = "w-24 h-14" }) {
  const base = `${className} rounded-md border border-zinc-200 object-cover flex-shrink-0`;
  if (fabric.orderPhoto) return <AuthImage src={attachmentImageUrl(orderId, fabric.orderPhoto)} alt={fabric.label} className={base} />;
  if (fabric.swatch) return <AuthImage src={swatchImageUrl(fabric.swatch)} alt={fabric.label} className={base} />;
  return (
    <div className={`${className} rounded-md border-2 border-dashed border-red-300 bg-red-50 flex flex-col items-center justify-center text-red-500 flex-shrink-0`}>
      <ImageOff className="w-4 h-4" />
      <span className="text-[9px] font-semibold uppercase mt-0.5">Pas de photo</span>
    </div>
  );
}

export function FabricCard({ idx, orderId, fabric, busy, onLibraryFile, onOrderFile, onRemoveOrderPhoto, onRemoveManual }) {
  const source = fabric.orderPhoto ? "Photo de la commande" : fabric.swatch ? "Bibliothèque" : "Aucune photo";
  const sourceClass = fabric.orderPhoto ? "text-purple-600" : fabric.swatch ? "text-emerald-600" : "text-red-500";
  return (
    <div className="flex items-center gap-3 p-2.5 rounded-lg border border-zinc-200 bg-white" data-testid={`fabric-card-${idx}`}>
      <FabricThumb orderId={orderId} fabric={fabric} />
      <div className="flex-1 min-w-0">
        <p className="font-bold text-zinc-900 tracking-wide text-base leading-tight" data-testid={`fabric-card-code-${idx}`}>{fabric.code}</p>
        <p className="text-xs text-zinc-600 truncate">{fabric.collection || "Collection inconnue"}{fabric.count > 1 ? ` · ×${fabric.count}` : ""}</p>
        <p className={`text-[10px] font-semibold uppercase tracking-wider mt-0.5 ${sourceClass}`} data-testid={`fabric-card-source-${idx}`}>
          {source}{fabric.manual && <span className="ml-1.5 text-zinc-400">· saisie manuelle</span>}
        </p>
      </div>
      {fabric.manual && (
        <button type="button" onClick={() => onRemoveManual(fabric.key)} disabled={busy} className="self-start p-1 rounded hover:bg-red-50 transition-colors" title="Retirer cette toile de la commande" data-testid={`fabric-card-remove-manual-${idx}`}>
          <X className="w-4 h-4 text-red-500" />
        </button>
      )}
      <div className="flex flex-col gap-1 items-stretch">
        <FilePickButton accept="image/*" onFile={onLibraryFile} disabled={busy} testId={`fabric-library-upload-${idx}`} className="h-7 text-xs gap-1.5">
          <Library className="w-3.5 h-3.5" />{fabric.swatch ? "Remplacer (biblio.)" : "Ajouter à la biblio."}
        </FilePickButton>
        {fabric.orderPhoto ? (
          <button type="button" onClick={() => onRemoveOrderPhoto(fabric.orderPhoto)} disabled={busy} className="h-7 text-xs px-2 rounded-md border border-zinc-200 text-zinc-600 hover:bg-zinc-100 inline-flex items-center justify-center gap-1.5 transition-colors" data-testid={`fabric-order-remove-${idx}`}>
            <X className="w-3.5 h-3.5" />Retirer photo commande
          </button>
        ) : (
          <FilePickButton accept="image/*" onFile={onOrderFile} disabled={busy} testId={`fabric-order-upload-${idx}`} className="h-7 text-xs gap-1.5">
            <Camera className="w-3.5 h-3.5" />Photo commande
          </FilePickButton>
        )}
      </div>
    </div>
  );
}
